import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import {
  formatUKDate,
  formatUKTime,
  minutesToHoursMinutes,
  renderPaidHours,
} from '../../utils/attendanceDateTime';
import AttendanceStatusBadge from './AttendanceStatusBadge';

export function PayrollDetailTable({ rows }) {
  if (!rows.length) {
    return (
      <div className="card-rtb">
        <p className="text-[#A1A1AA]">No payroll rows found for this venue/week.</p>
      </div>
    );
  }

  return (
    <div className="card-rtb overflow-x-auto" data-testid="payroll-detail-table">
      <h4 className="font-heading text-xl uppercase text-white mb-3">Weekly Shift Detail</h4>
      <Table>
        <TableHeader>
          <TableRow className="border-[#3F3F46]">
            <TableHead>Staff</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Date</TableHead>
            <TableHead>Clock In</TableHead>
            <TableHead>Clock Out</TableHead>
            <TableHead>Break</TableHead>
            <TableHead>Paid</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Source</TableHead>
            <TableHead>Edited</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id || row.time_entry_id} className="border-[#27272A]">
              <TableCell className="text-white">{row.staff_name || '-'}</TableCell>
              <TableCell className="text-[#A1A1AA] uppercase">{row.role || '-'}</TableCell>
              <TableCell className="text-[#E4E4E7]">{formatUKDate(row.shift_date || row.clock_in_at)}</TableCell>
              <TableCell className="text-[#E4E4E7]">{formatUKTime(row.clock_in_at)}</TableCell>
              <TableCell className="text-[#E4E4E7]">{row.clock_out_at ? formatUKTime(row.clock_out_at) : '-'}</TableCell>
              <TableCell className="text-[#E4E4E7]">{minutesToHoursMinutes(row.break_minutes || 0)}</TableCell>
              <TableCell className="text-[#E4E4E7]">{renderPaidHours(row.paid_hours || 0)}</TableCell>
              <TableCell><AttendanceStatusBadge status={row.status || (row.clock_out_at ? 'closed' : 'open')} /></TableCell>
              <TableCell className="text-[#A1A1AA]">{row.source || '-'}</TableCell>
              <TableCell className="text-[#A1A1AA]">{row.edited ? 'Yes' : 'No'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export function PayrollGroupedTable({ rows }) {
  if (!rows.length) return null;

  return (
    <div className="card-rtb overflow-x-auto" data-testid="payroll-grouped-summary-table">
      <h4 className="font-heading text-xl uppercase text-white mb-3">Grouped By Staff</h4>
      <Table>
        <TableHeader>
          <TableRow className="border-[#3F3F46]">
            <TableHead>Staff</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Shifts</TableHead>
            <TableHead>Total Paid Hours</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.user_id || row.staff_name} className="border-[#27272A]">
              <TableCell className="text-white">{row.staff_name}</TableCell>
              <TableCell className="text-[#A1A1AA] uppercase">{row.role}</TableCell>
              <TableCell className="text-[#E4E4E7]">{row.shift_count}</TableCell>
              <TableCell className="text-[#E4E4E7]">{renderPaidHours(row.total_paid_hours)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
